var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Strony opisowe")]),
      _c(
        "v-row",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "success",
              on: {
                click: function($event) {
                  return _vm.$router.push("/settings/custom-webpage/edit/new")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("settings.customWebpage.newButton")))]
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: { items: _vm.customWebpages, headers: _vm.headers },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled:
                                              props.item.order_number === 1,
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.moveUp(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-arrow-alt-circle-up")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.moveUp")) + " ")]
                      ),
                      _vm._v(" " + _vm._s(props.item.order_number) + " "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled:
                                              props.item.order_number ===
                                              _vm.customWebpages.length,
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.moveDown(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-arrow-alt-circle-down")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.moveDown")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c("v-icon", [_vm._v(_vm._s(props.item.icon))]),
                      _vm._v(" " + _vm._s(props.item.icon) + " ")
                    ],
                    1
                  ),
                  _c("td", [_vm._v(" " + _vm._s(props.item.alias) + " ")]),
                  _c("td", [_vm._v(" " + _vm._s(props.item.title) + " ")]),
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            to:
                                              "/settings/custom-webpage/edit/" +
                                              props.item.id,
                                            icon: ""
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("edit")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.remove(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }